export const orderLevelTrackingNo = (order) =>
  order?.consignNote || order?.consign_no || null;

export const orderTrackingNos = (order) => {
  if (!order) return [];

  const pieceNos = (order.pieces || [])
    .map((piece) => piece?.deliveryConfirmationNo || piece?.consign_no)
    .filter(Boolean);
  if (pieceNos.length > 0) return pieceNos;

  const orderNo = orderLevelTrackingNo(order);
  return orderNo ? [orderNo] : [];
};

export const formatTrackingNos = (order) => orderTrackingNos(order).join(", ");

// The label PDF is stored in S3 under the piece's consign_no, while
// deliveryConfirmationNo is the number the merchant tracks with. /consign-pdf
// builds the S3 key straight from whatever it is given, so downloads must send
// consign_no even though the UI shows the tracking number.
//
// labelConsignNo falls back to deliveryConfirmationNo only for a piece that has
// no consign_no at all. That is not a working S3 key, but it is still the right
// thing to send: the bulk endpoint resolves it back to the order's real consign
// numbers, and dropping the target instead would leave the merchant with no
// download button rather than a working one.
export const orderLabelTargets = (order) => {
  if (!order) return [];

  const pieceTargets = (order.pieces || [])
    .map((piece) => ({
      trackingNo: piece?.deliveryConfirmationNo || piece?.consign_no,
      labelConsignNo: piece?.consign_no || piece?.deliveryConfirmationNo,
    }))
    .filter((target) => target.trackingNo && target.labelConsignNo);
  if (pieceTargets.length > 0) return pieceTargets;

  const orderNo = orderLevelTrackingNo(order);
  return orderNo ? [{ trackingNo: orderNo, labelConsignNo: orderNo }] : [];
};
